import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { clinic, openingHours, socialLinks } from "../../data/clinic";
import { mainNavigation } from "../../data/navigation";
export function SiteFooter() {
  return <footer className="bg-ink text-white/70" data-id="element-274" data-mp="t1kwu7yeusi2">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 md:grid-cols-12 md:px-8" data-id="element-275" data-mp="xybaypqnne0u">
        <div className="md:col-span-4" data-id="element-276" data-mp="1looufrv6c4jt">
          <Logo inverted data-id="element-277" data-mp="1lpqgerdqabgb" />
          <p className="mt-4 max-w-xs text-sm leading-relaxed" data-id="element-278" data-mp="1lmcdni15k08c">
            Kinésithérapie, ostéopathie, orthophonie et psychomotricité au cœur d'Étréchy.
          </p>
        </div>

        <div className="md:col-span-3" data-id="element-279" data-mp="1cn7ec9hro2v4">
          <h2 className="text-sm font-semibold text-white" data-id="element-280" data-mp="1gpcb3h3ihflz">Cabinet</h2>
          <address className="mt-3 text-sm not-italic leading-relaxed" data-id="element-281" data-mp="1grf84l330907">
            {clinic.street}
            <br data-id="element-282" data-mp="1aoif2wpcfso" />
            {clinic.city}
          </address>
          <a href={clinic.phoneHref} className="mt-2 block text-sm text-white hover:underline" data-id="element-283" data-mp="5b8d7ztsz7bn">
            {clinic.phone}
          </a>
        </div>

        <div className="md:col-span-3" data-id="element-284" data-mp="1xxbitx0rtp02">
          <h2 className="text-sm font-semibold text-white" data-id="element-285" data-mp="1sxfh64fjq9no">Horaires</h2>
          <dl className="mt-3 space-y-1.5 text-sm" data-id="element-286" data-mp="26vx1rta5n61d">
            {openingHours.map(row => <div key={row.day} data-id="element-287" data-mp="22utl54ka95z3">
                <dt className="text-white/90" data-id="element-288" data-mp="22tifez7a1o5c">{row.day}</dt>
                <dd data-id="element-289" data-mp="2gucrpsxg499a">{row.hours}</dd>
              </div>)}
          </dl>
        </div>

        <nav aria-label="Liens du pied de page" className="md:col-span-2" data-id="element-290" data-mp="2bv9l441thuz7">
          <h2 className="text-sm font-semibold text-white" data-id="element-291" data-mp="2bt5lhyaybi4q">Navigation</h2>
          <ul className="mt-3 space-y-1.5 text-sm" data-id="element-292" data-mp="2qiuqy5q2u8at">
            {mainNavigation.map(item => <li key={item.to} data-id="element-293" data-mp="2lmdzp2nkzdti">
                <Link to={item.to} className="transition-colors duration-150 hover:text-white" data-id="element-294" data-mp="2lnfdhevzeeex">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>
      </div>

      <div className="border-t border-white/10" data-id="element-295" data-mp="1s8levfinbtkd">
        <div className="mx-auto flex max-w-6xl flex-col gap-3 px-5 py-6 text-xs md:flex-row md:items-center md:justify-between md:px-8" data-id="element-296" data-mp="1s9winfc3d1bh">
          <p data-id="element-297" data-mp="2191g0ibx2om2">© {new Date().getFullYear()} RD-Kiné · Tous droits réservés</p>
          <div className="flex items-center gap-5" data-id="element-298" data-mp="216x0t48ki36h">
            {socialLinks.map(s => <a key={s.label} href={s.href} target="_blank" rel="noreferrer" className="hover:text-white" data-id="element-299" data-mp="2611ahv97wpb9">
                {s.label}
              </a>)}
            <Link to="/mentions-legales" className="hover:text-white" data-id="element-300" data-mp="2fwuuu0t6hn3l">
              Mentions légales
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}